export interface ApiCdrSummaryStatisticOrg {
  calldate: string;
  organization_id: string;
  origination: string;
  termination: string;
}

export interface ApiCdrSummaryStatisticUser {
  name: string;
  origination: string;
  termination: string;
  user_id: string;
}

export interface ApiCdrSummaryStatisticPhone {
  e164: string;
  organization_id: string;
  origination: string;
  termination: string;
  user_id: string;
}

export interface CdrSummaryStatisticOrg {
  calldate: string;
  organizationId: string;
  origination: string;
  termination: string;
}

export interface CdrSummaryStatisticUser {
  name: string;
  origination: string;
  termination: string;
  userId: string;
}

export interface CdrSummaryStatisticPhone {
  e164: string;
  organizationId: string;
  origination: string;
  termination: string;
  userId: string;
}

export function apiCdrOrgToCdrOrg(apiCdrOrg: ApiCdrSummaryStatisticOrg): CdrSummaryStatisticOrg {
  return {
    calldate: apiCdrOrg.calldate,
    organizationId: apiCdrOrg.organization_id,
    origination: apiCdrOrg.origination,
    termination: apiCdrOrg.termination
  };
}

export function apiCdrUserToCdrUser(
  apiCdrUser: ApiCdrSummaryStatisticUser
): CdrSummaryStatisticUser {
  return {
    name: apiCdrUser.name,
    origination: apiCdrUser.origination,
    termination: apiCdrUser.termination,
    userId: apiCdrUser.user_id
  };
}

export function apiCdrPhoneToCdrPhone(
  apiCdrPhone: ApiCdrSummaryStatisticPhone
): CdrSummaryStatisticPhone {
  return {
    e164: apiCdrPhone.e164,
    organizationId: apiCdrPhone.organization_id,
    origination: apiCdrPhone.origination,
    termination: apiCdrPhone.termination,
    userId: apiCdrPhone.user_id
  };
}

export interface CdrSummaryStatisticParams {
  OrganizationId?: string;
  /** date time should be in YYYY-MM-DD format */
  StartDateTime?: string;
  /** date time should be in YYYY-MM-DD format */
  EndDateTime?: string;
}
